import React from 'react';

function App() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      <iframe
        
       src="https://uniform.scholarclothings.in/app/scholar-appsmith-lite/loginpage-68778d35c3389c62786ad1a6?branch=Production&embed=true"
        width="98%"
        height="98%"
        style={{ border: "none" }}
        allowFullScreen
      />
    </div>
  );
}

export default App;
